export enum FileType {
  Image = 'image',
  Video = 'video',
  Audio = 'audio',
  Document = 'document',
  Zip = 'archive',
  VectorArt = 'shape',
  SWF = 'swf',
}
